import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import MyControlBar from "./MyControlBar/MyControlBar";
import MediaArray from "./MediaArray/MediaArray";
import SpaceSideContainer from "./SpaceSideContainer/SpaceSideContainer";
import RemoteMediaControls from "./MediaArray/RemoteMediaControls/RemoteMediaControls";
import { useSelector } from "react-redux";
import { selectSpaceBoxActive } from "slices/spaceMediaSlice";

const VideoBar = () => {
  const spaceBoxActive = useSelector(selectSpaceBoxActive);

  useEffect(() => {
    document.getElementById("videobar").classList.add("space-active");
    return () => {
      document.getElementById("videobar").classList.remove("space-active");
    };
  }, []);

  useEffect(() => {
    if (!spaceBoxActive)
      document.getElementById("videobar").classList.add("space-box-minimised");
    else
      document
        .getElementById("videobar")
        .classList.remove("space-box-minimised");
  }, [spaceBoxActive]);

  return ReactDOM.createPortal(
    <>
      <MyControlBar />
      <RemoteMediaControls />
      <MediaArray />
      <SpaceSideContainer />
    </>,
    document.querySelector("#videobar")
  );
};
export default VideoBar;
